import Text from '@/components/basic/text';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import globalStore from '@/services/global.state';
import theme from '@/style';
import {goTo, toPriceStr} from '@/utils';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {View, StyleSheet} from 'react-native';
import Svg, {Rect, Path, Circle} from 'react-native-svg';

export interface WalletProps {
  theme?: 'dark' | 'light';
}

const Wallet: React.FC<WalletProps> = ({theme: walletTheme = 'light'}) => {
  const [login, setLogin] = useState(false);
  const [amount, setAmount] = React.useState(0);
  const {i18n} = useTranslation();
  React.useEffect(() => {
    const amountSub = globalStore.amountChanged.subscribe(res => {
      setAmount(res.current);
    });
    const sub = globalStore.tokenSubject.subscribe(token => {
      setLogin(!!token);
    });
    return () => {
      amountSub.unsubscribe();
      sub.unsubscribe();
    };
  }, []);
  return (
    <NativeTouchableOpacity
      onPress={() => {
        goTo('Recharge');
      }}
      style={[theme.flex.row, theme.flex.centerByCol]}>
      <View style={styles.textWrap}>
        <Text
          fontSize={10}
          textAlign="right"
          color={
            walletTheme === 'light'
              ? theme.basicColor.white
              : theme.fontColor.accent
          }>
          {i18n.t('label.balance')}
        </Text>
        <Text
          textAlign="right"
          blod
          fontSize={12}
          color={
            walletTheme === 'light'
              ? theme.basicColor.white
              : theme.fontColor.main
          }>
          {login ? toPriceStr(amount, {suffixUnit: 'K'}) : '-'}
        </Text>
      </View>
      <WalletIcon />
    </NativeTouchableOpacity>
  );
};

export const WalletIcon = ({
  width = 25,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <Svg width={width} height={height} viewBox="0 0 25 24" fill="none">
    <Rect y={3.42871} width={24} height={20.5714} rx={3.42856} fill="#F59E4E" />
    <Rect
      x={0.819336}
      y={8.43408}
      width={16.868}
      height={9.76926}
      rx={1.71428}
      transform="rotate(-30 0.819336 8.43408)"
      fill="#FFD02E"
    />
    <Rect y={6.85693} width={24} height={17.1429} rx={3.42856} fill="#F97316" />
    <Rect
      x={0.42857}
      y={7.2855}
      width={23.1429}
      height={16.2857}
      rx={3}
      stroke="white"
      strokeOpacity={0.1}
      strokeWidth={0.85714}
    />
    <Path
      d="M15.4287 15.4288C15.4287 17.091 16.7762 18.4386 18.4385 18.4386H23.9982V12.4189H18.4385C16.7762 12.4189 15.4287 13.7665 15.4287 15.4288Z"
      fill="white"
      opacity={0.6}
    />
    <Circle cx={18.2469} cy={15.4285} r={1.46609} fill="#F97316" />
  </Svg>
);

const styles = StyleSheet.create({
  textWrap: {
    marginRight: 4,
  },
});

export default Wallet;
